import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getStockAdjustment = createAsyncThunk(
    "/prosafe/getStockAdjustment",
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-list-stock-adjustment`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to fetch stock adjustments");
            }
        } catch (error) {
            const errMsg = error.response?.data?.message || error.message || "Failed to fetch stock adjustments";
            toast.error(errMsg);
            throw error;
        }
    }
);

const getStockAdjustmentSlice = createSlice({
    name: "getStockAdjustment",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStockAdjustment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getStockAdjustment.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getStockAdjustment.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getStockAdjustmentSlice.reducer;
